import { Box, Stack } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import ScrollToTop from "../../hooks/scroll-to-top";
import userIsOnline from "../../hooks/use-online";
import ErrorBoundaryPage from "../../Error/ErrorBoundaryPage";
import { AppBar } from "./AppBar";
import { Footer } from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  if (isDashboard) {
    return <>{children}</>;
  }

  return (
    <React.Fragment>
      <Box>
        {ScrollToTop()}
        <AppBar />

        <Stack direction="row" component="main">
          <Box
            sx={{
              backgroundColor: "#ffffff",
              flexGrow: 1,
              overflow: "auto",
            }}
          >
            {userIsOnline ? (
              children
            ) : (
              <ErrorBoundaryPage
                title="No connection"
                content="It looks like you are offline. Please check your internet connection."
                buttonLabel="Retry"
                onButtonClick={() => window.location.reload()}
                includeFooter
              />
            )}
          </Box>
        </Stack>
        <Footer />
      </Box>
    </React.Fragment>
  );
};

export default Layout;
